/* global  attachEvent */

// *******************************************************************************
// Open Gallery Modal
// *******************************************************************************

attachEvent('.image-card:not(.image-card--external-link)', 'click', (ev) => {
  const imageCardEle = ev.target.closest('.image-card__wrapper');
  const imageGalleryModal = imageCardEle.querySelector('.gallery-modal');
  imageGalleryModal.classList.add('is-open-gallery-modal');
});
